export default "__VITE_ASSET__IgkSfBKi__"